import React, { Component } from "react";
import axios from "axios";
import Slider from "react-slick";
import constant from "../../constant";
import FavAction from "../FavoritesComp/FavAction";
import { LoadingComp } from "../../components/LoadingComp";

import { connect } from "react-redux";
import { getSigleCurrency } from "../../store/actions/singleCurrencyActions";
import "./style.scss";

class WorkspaceComp extends Component {
  constructor(props) {
    super(props);
    this.state = {
      spaces: null,
      show_loading: 1
    };
  }

  componentDidMount() {
    let curr = JSON.parse(localStorage.getItem("O_Auth"));
    this.props.getSigleCurrency(curr ? curr.currency : 1);
    axios
      .get(`${constant.phpHost}action/newspace.php`, {
        params: {
          todo: "get_spaces_on_home",
          city_id: this.props.city_id,
          country_id: this.props.country_id
        }
      })
      .then(res => {
        this.setState({
          spaces: res.data,
          show_loading: 0
        });
      });
  }

  priceCalculation = price => {
    let cur_code = this.props.singleCurrency.code;
    let cur_value = this.props.singleCurrency.value;
    return this.codeOnly(cur_code) + " " + this.priceOnly(price, cur_value);
  };

  priceOnly = (price, cur_value) => {
    return (price /= cur_value).toFixed(2);
  };

  codeOnly = cur_code => {
    if (cur_code === "INR") {
      cur_code = "₹";
    }

    if (cur_code === "EUR") {
      cur_code = "€";
    }

    return cur_code;
  };

  render() {
    var settings = {
      dots: false,
      infinite: false,
      speed: 500,
      slidesToShow: 4,
      slidesToScroll: 1,
      lazyLoad: "ondemand",
      initOnLoad: true,
      nextSlidesToPreload: 1,
      // fade: true,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 3
          }
        },
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1.2
          }
        }
      ]
    };

    return this.state.show_loading === 0 ? (
      <section id="home-workspace">
        <div className="title">
          <h1>
            {this.props.title} {this.props.location}
          </h1>
          <p>{this.props.text}</p>
        </div>

        <Slider {...settings}>
          {this.state.spaces &&
            this.state.spaces.map((list, i) => (
              <div className="Seach_desk" key={i}>
                <a href={list.url}>
                  <img
                    className="space-image"
                    src={list.images[0]}
                    alt=""
                    key={i}
                  />
                </a>

                <div className="text">
                  <h3>
                    <a href={list.url}>{list.title}</a>
                    <FavAction space_id={list.id} />
                  </h3>
                  <p>
                    <i>{list.location.place}</i>
                  </p>
                  <p className="price">
                    <strong>{this.priceCalculation(list.price)}</strong>{" "}
                    {list.isLongTerms === 1 ? (
                      <span>/{list.long_term}</span>
                    ) : (
                      <span>/{list.space.type === 1 ? "day" : "hour"}</span>
                    )}
                  </p>

                  <p className="upto">
                    Up to {list.space.quantity} {list.space.q_name}{" "}
                    {list.isLongTerms === 1 ? (
                      <span className="long-term">Long Term</span>
                    ) : list.discount ? (
                      <span className="discount">Discount</span>
                    ) : null}
                  </p>
                </div>
              </div>
            ))}
        </Slider>
      </section>
    ) : (
      <LoadingComp customStyle={{ padding: "150px 0" }} />
    );
  }
}

const mapStateToProps = state => {
  return {
    singleCurrency: state.singleCurrency.data
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getSigleCurrency: id => dispatch(getSigleCurrency(id))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(WorkspaceComp);
